var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 384,
    height: 263,
    viewBox: "0 0 384 263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6483",
    "data-name": "Rectangle 6483",
    width: 384,
    height: 263,
    rx: 12,
    transform: "translate(420 332)",
    fill: "#fff",
    stroke: "#d8d8d8",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4177",
    "data-name": "Mask Group 4177",
    transform: "translate(-420 -332)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20681",
    "data-name": "Group 20681",
    transform: "matrix(0.719, -0.695, 0.695, 0.719, -541.707, 215.471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6482",
    "data-name": "Rectangle 6482",
    width: 124,
    height: 34,
    transform: "translate(552 782)",
    fill: "#61ca77"
  }), /*#__PURE__*/React.createElement("text", {
    id: "DEFAULT",
    transform: "translate(584.5 803.5)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Figtree-Regular, Figtree"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEFAULT"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default_icon.f1c2ad0730c2587a69ee627fe9e9ff86.svg";
export { ForwardRef as ReactComponent };